import React, { useReducer, useEffect } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

export const AccountContext = React.createContext();
export const SET_ACTIVE_PERSON = "set_active_person";

const WHOAMI = gql`
  query {
    member {
      saleHistory {
        id
        customerId
        receiptNumber
        saleDate
        totalExclVat
        totalInclVat
        posId
        posName
      }
      subscriptionHistory {
        customerId
        uniqueIdentifier
        registrationDate
        subscriptionId
        subscriptionTypeName
      }
    }
    whoami {
      details {
        id
        name
        firstname
        lastname
        photo
        civicRegistrationNumber
        hasAssociation
        associatedWith {
          id
          name
        }
        addresses {
          type
          isEmpty
          street
          streetNumber
          zipCode
          city
          countryCode
        }
        phonenumbers {
          type
          isEmpty
          number
        }
        manages {
          id
          name
          firstname
          lastname
          photo
          email
          civicRegistrationNumber
          hasAssociation
          associatedWith {
            id
            name
          }
          addresses {
            type
            isEmpty
            street
            streetNumber
            zipCode
            city
            countryCode
          }
          phonenumbers {
            type
            isEmpty
            number
          }
        }
        email
      }
      photo
    }
  }
`;

const initialState = {
  activePerson: {},
};
const reducer = (state, action) => {
  switch (action.type) {
    case SET_ACTIVE_PERSON:
      return { ...state, activePerson: action.payload };
    default:
      throw new Error(`Wrong action type: ${action.type}`);
  }
};

const AccountProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const config = useSelector((state) => state.infrastructure.config);
  const { loading, error, data } = useQuery(WHOAMI);
  const accountData = loading ? null : data;
  const getIsSelf = () => {
    if (!accountData) return true;
    return accountData.whoami.details.id === state.activePerson.id;
  };
  useEffect(() => {
    if (!data) return;
    if (data.whoami && !state.activePerson.id) {
      dispatch({ type: SET_ACTIVE_PERSON, payload: data.whoami.details });
    }
  }, [data, state.activePerson]);

  if (error) return <h3>{error.message}</h3>;
  return (
    <AccountContext.Provider
      value={{
        state: { ...state, accountData, config, isSelf: getIsSelf() },
        dispatch,
      }}
    >
      {props.children}
    </AccountContext.Provider>
  );
};

export default AccountProvider;
